module.exports = __webpack_public_path__ + "img/icon_heart.3d80d5ca.svg";